import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import PublicLinkModal
  from '@avtechsoftware/react-component-library/src/components/metrics/PublicLinkModal/PublicLinkModal';
import { connect } from 'react-redux';
import envConfig from '../../../envConfig';
import { RaaRoles, sessionUserHasRolePrivileges } from '../../../utility/SecurityRules';
import {
  selectSessionInformation, sessionInformationPropType,
} from '../../../redux/slices/sessionSlice';
import RaaAuthenticatedRemoteService from '../../../utility/RaaAuthenticatedRemoteService';
import {
  fetchMetricGroups,
  selectMetricGroupById,
} from '../../../redux/slices/metricsGroupSlice/metricsGroupSlice';

class PublicReportModalConnected extends React.Component {
  constructor(props) {
    super(props);
    const { findMetricGroupById, id } = props;
    const { publicLinkHash } = findMetricGroupById(id) || null;
    const publicReportUrl = publicLinkHash
      ? `${envConfig.raaUrl}/public/report/${findMetricGroupById(id).publicLinkHash}`
      : '';
    this.state = {
      publicReportUrl,
    };
    this.onCreatePublicLink = this.onCreatePublicLink.bind(this);
    this.onDeletePublicLink = this.onDeletePublicLink.bind(this);
  }

  onCreatePublicLink() {
    const { id, dispatch } = this.props;
    const formData = new FormData();
    formData.append('channelReportId', id);
    return RaaAuthenticatedRemoteService.globalInstance().post('/reports/data/generate-new-public-link', { data: formData })
      .then((response) => {
        this.setState({ publicReportUrl: response });
        dispatch(fetchMetricGroups());
      }).catch(() => {});
  }

  onDeletePublicLink() {
    const { id, dispatch } = this.props;
    const formData = new FormData();
    formData.append('channelReportId', id);
    return RaaAuthenticatedRemoteService.globalInstance().post(`${envConfig.raaUrl}/reports/data/delete-public-link`, { data: formData })
      .then(() => {
        this.setState({ publicReportUrl: '' });
        dispatch(fetchMetricGroups());
      }).catch(() => {});
  }

  /* istanbul ignore next */
  render() {
    const { publicReportUrl } = this.state;
    const { hideModal, sessionInformation } = this.props;
    return (
      <>
        <PublicLinkModal
          publicLinkUrl={publicReportUrl}
          onRefreshPublicLink={this.onCreatePublicLink}
          onDeletePublicLink={this.onDeletePublicLink}
          onClose={hideModal}
          userHasEditPrivileges={
            sessionUserHasRolePrivileges(
              sessionInformation.activeSubscription, [RaaRoles.ADMIN, RaaRoles.MANAGER],
            )
          }
        />
      </>
    );
  }
}

PublicReportModalConnected.propTypes = {
  id: PropTypes.number.isRequired,
  metricsGroupContext: PropTypes.shape({
    findById: PropTypes.func.isRequired,
  }).isRequired,
  hideModal: PropTypes.func.isRequired,
  sessionInformation: sessionInformationPropType.isRequired,
  dispatch: PropTypes.func.isRequired,
  findMetricGroupById: PropTypes.func.isRequired,
};
/* istanbul ignore next */
const mapStateToProps = (state) => ({
  sessionInformation: selectSessionInformation(state),
  findMetricGroupById: (id) => selectMetricGroupById(state, id),
});
export { PublicReportModalConnected };

export default withRouter(
  connect(mapStateToProps)(PublicReportModalConnected),
);
